import React, {FC, useState} from 'react';
import {connect} from 'react-redux';

import {ResolveDispatchProps} from '../../../../helpers/reduxHelpers';
import {makeMapStateToProps, ResolveStateProps} from '../../../../helpers/reselectHelpers';
import {
  getDaysLeftInDiscount,
  getShouldDisplayCustomPricingAlert,
} from '../../../../store/data/company/companySelectors';
import {
  getIsUserBillingContact,
  getIsUserGlobalAdmin,
} from '../../../../store/data/teammates/teammatesSelectors';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {DiscountEndingBanner} from './discountEndingBanner';

/*
 * Props.
 */

type DiscountEndingBannerContainerStateProps = ResolveStateProps<typeof mapStateToProps>;
type DiscountEndingBannerContainerDispatchProps = ResolveDispatchProps<typeof mapDispatchToProps>;
type DiscountEndingBannerContainerComponentProps = DiscountEndingBannerContainerStateProps &
  DiscountEndingBannerContainerDispatchProps;

/*
 * Component.
 */

export const DiscountEndingBannerContainerComponent: FC<DiscountEndingBannerContainerComponentProps> = (
  props,
) => {
  const {isGlobalAdmin, isBillingContact, daysLeftInDiscount, shouldDisplayCustomPricingAlert, contactSales} =
    props;
  const [isDismissed, setIsDismissed] = useState(false);

  // At 2 and 1 days, pricing conversations should have been started
  const shouldDisplayBanner =
    isGlobalAdmin &&
    isBillingContact &&
    daysLeftInDiscount &&
    daysLeftInDiscount >= 3 &&
    daysLeftInDiscount <= 7 &&
    !isDismissed &&
    shouldDisplayCustomPricingAlert;

  if (!shouldDisplayBanner) {
    return null;
  }

  return (
    <DiscountEndingBanner
      daysLeftInDiscount={daysLeftInDiscount}
      onDismissClick={() => setIsDismissed(true)}
      onLinkClick={contactSales}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isGlobalAdmin: getIsUserGlobalAdmin,
  daysLeftInDiscount: getDaysLeftInDiscount,
  shouldDisplayCustomPricingAlert: getShouldDisplayCustomPricingAlert,
  isBillingContact: getIsUserBillingContact,
}));

const mapDispatchToProps = {
  contactSales: () => navigateToLinkAction('mailto:sales@frontapp.com'),
};

export const DiscountEndingBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountEndingBannerContainerComponent);
